(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('[data-carousel]');
      if (!root || root.dataset.carouselReady) return;
      root.dataset.carouselReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
      if (slides.length < 2) return;

      var dotsWrap = root.querySelector('[data-dots]');
      var interval = parseInt(root.dataset.interval, 10) || 7000;
      var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (index < 0) index = 0;
      var timer = null;

      var dots = slides.map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hero-dot' + (i === index ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); restart(); });
        if (dotsWrap) dotsWrap.appendChild(b);
        return b;
      });

      function go(i) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (i + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }

      function restart() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () { go(index + 1); }, interval);
      }

      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(index + 1); restart(); });

      restart();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('.pdp');
      if (!root || root.dataset.pdpReady) return;
      root.dataset.pdpReady = '1';

      // ---- Media gallery ----
      var items = root.querySelectorAll('[data-media-index]');
      root.querySelectorAll('[data-thumb-index]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.dataset.thumbIndex;
          items.forEach(function (it) {
            it.classList.toggle('is-active', it.dataset.mediaIndex === idx);
          });
          root.querySelectorAll('[data-thumb-index]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });

      // ---- Quantity stepper ----
      var qty = root.querySelector('[data-qty-input]');
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (qty && minus && plus) {
        minus.addEventListener('click', function () {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
        });
        plus.addEventListener('click', function () {
          qty.value = (parseInt(qty.value, 10) || 1) + 1;
        });
      }

      // ---- Variant pills -> re-match variant, update price/availability ----
      var dataEl = document.querySelector('[data-pdp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var optionSets = root.querySelectorAll('.pdp-option');
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var idInput = root.querySelector('[data-pdp-variant-id]');
      var atc = root.querySelector('[data-pdp-atc]');

      function selectedOptions() {
        var out = [];
        optionSets.forEach(function (set) {
          var sel = set.querySelector('.pdp-pill.is-selected');
          out[parseInt(set.dataset.optionIndex, 10)] = sel ? sel.dataset.optionValue : null;
        });
        return out;
      }

      function applyVariant() {
        var opts = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.textContent = match.price;
          if (compareEl) {
            if (match.compare) {
              compareEl.textContent = match.compare;
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          if (atc) {
            atc.disabled = !match.available;
            atc.textContent = match.available ? 'Add to cart' : 'Sold out';
          }
        } else if (atc) {
          atc.disabled = true;
          atc.textContent = 'Unavailable';
        }
      }

      optionSets.forEach(function (set) {
        set.querySelectorAll('.pdp-pill').forEach(function (pill) {
          pill.addEventListener('click', function () {
            set.querySelectorAll('.pdp-pill').forEach(function (p) {
              p.classList.toggle('is-selected', p === pill);
            });
            applyVariant();
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
